import React, { Component } from 'react';
import { Context } from 'context';

import styles from 'components/menu/Menu.module.scss';
import Expander from "components/expander/Expander";

class Menu extends Component {
    static contextType = Context;

    render() {
        return (
            <Expander
                className={styles.menu}
                closedClassName={styles.closed}
                startClosed={true}
            >
                <div className={`highlightSecondary ${styles.header}`} data-hint={this.props.hint} title={this.props.title}>
                    <img src={this.props.iconSrc} alt={this.props.iconAlt} />
                </div>
                <div className={`bgTertiary highlightTertiary ${styles.items}`}>
                    {this.props.children}
                </div>
            </Expander>
        )
    }
}

export default Menu;
